<template>
  <a :href="notification.data.action_url" class="kt-notification__item kt-notification__item">
    <div class="dismiss-notification" @click.prevent.stop="markAsRead">
      <button type="button" class="btn btn-sm btn-outline-hover-danger btn-icon" @click.prevent.stop="markAsRead"><i class="la la-close" /></button>
    </div>
    <div v-if="notification.data.icon" class="kt-notification__item-icon">
      <img :src="notification.data.icon">
    </div>
    <div class="kt-notification__item-details notif-container">
      <div class="kt-notification__item-title notif-title"> {{ notification.data.title }} </div>
      <span v-sanitise="notification.data.body" class="notification__item-body notif-body" />
      <div class="kt-notification__item-time notif-time">  <timeago :datetime="notification.created" :auto-update="30" /> </div>
    </div>
  </a>
</template>

<script>
export default {

  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  methods: {
    markAsRead() {
      this.$emit('read');
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";

@use "~AssetsSass/_variables" as *;

.dismiss-notification {
  flex: 0 0 2.5rem
}

.notif-container {
  .notif-title {
    font-weight: 700 !important;
  }

  &:hover {
    .notif-title {
      color: map.get($ss, 'primary') !important;
    }
  }
}
</style>
